// extracted by mini-css-extract-plugin
export default {"main":"Product_main__4qrxu","article":"Product_article__lFGrg","image":"Product_image__bhIdN","text":"Product_text__Wfz1M","description":"Product_description__t3yNG"};